import { render, staticRenderFns } from "./serviceOne.vue?vue&type=template&id=bb9babec&"
import script from "./serviceOne.vue?vue&type=script&lang=js&"
export * from "./serviceOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports